import { create } from "zustand"

interface VoiceTranscriptionState {
  isActive: boolean
  focusedElement: Element | null
  selectionStart: number | null
  selectionEnd: number | null
  stopCallback: (() => void) | null
  trigger: (element?: Element | null) => void
  close: () => void
  registerStopCallback: (callback: () => void) => void
  unregisterStopCallback: () => void
  stop: () => void
}

export const useVoiceTranscriptionStore = create<VoiceTranscriptionState>((set, get) => ({
  isActive: false,
  focusedElement: null,
  selectionStart: null,
  selectionEnd: null,
  stopCallback: null,
  trigger: (element?: Element | null) => {
    const activeElement = element ?? document.activeElement
    let start: number | null = null
    let end: number | null = null

    if (activeElement instanceof HTMLInputElement || activeElement instanceof HTMLTextAreaElement) {
      start = activeElement.selectionStart ?? 0
      end = activeElement.selectionEnd ?? 0
    }

    set({
      isActive: true,
      focusedElement: activeElement,
      selectionStart: start,
      selectionEnd: end,
    })
  },
  close: () =>
    set({
      isActive: false,
      focusedElement: null,
      selectionStart: null,
      selectionEnd: null,
    }),
  registerStopCallback: (callback) => set({ stopCallback: callback }),
  unregisterStopCallback: () => set({ stopCallback: null }),
  stop: () => {
    const { stopCallback } = get()
    if (stopCallback) {
      stopCallback()
    }
  },
}))
